var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.9543 9.9543 1 21 1C32.0457 1 41 9.9543 41 21C41 32.0457 32.0457 41 21 41C9.9543 41 1 32.0457 1 21Z",
    stroke: "#82B5D1",
    strokeWidth: 1.42857
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2208 16.0609C30.9755 15.1183 30.2526 14.3762 29.3346 14.1243C27.6711 13.6665 21 13.6665 21 13.6665C21 13.6665 14.3288 13.6665 12.6652 14.1243C11.7472 14.3762 11.0243 15.1183 10.779 16.0609C10.3333 17.769 10.3333 21.3332 10.3333 21.3332C10.3333 21.3332 10.3333 24.8972 10.779 26.6055C11.0243 27.548 11.7472 28.2902 12.6652 28.5422C14.3288 28.9998 21 28.9998 21 28.9998C21 28.9998 27.6711 28.9998 29.3346 28.5422C30.2526 28.2902 30.9755 27.548 31.2208 26.6055C31.6666 24.8972 31.6666 21.3332 31.6666 21.3332C31.6666 21.3332 31.6666 17.769 31.2208 16.0609",
    stroke: "#82B5D1",
    strokeWidth: 1.42857
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 25.0002V18.3335L24.3333 21.667L18.9999 25.0002Z",
    stroke: "#82B5D1",
    strokeWidth: 1.42857
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e41c535cc634c6692ec2e6de82a97eb8.svg";
export { ForwardRef as ReactComponent };